(function () {
  "use strict";

  var module = angular.module("uwAgenda.global");
  module.controller("DatepickerController", [
    "$scope",
    "$timeout",
    "SharedAgendaService",
    "DateService",
    "CalendarBroadcast",
    "SharedAgendaBroadcast",
    'AgendaBroadcast',
    'WebsocketService',
    'WebsocketRegisterType',
    DatepickerControllerFn
  ]);

  /* Controller for the main - datepicker on secondary navigation */
  function DatepickerControllerFn(
    $scope,
    $timeout,
    SharedAgendaService,
    DateService,
    CalendarBroadcast,
    SharedAgendaBroadcast,
    AgendaBroadcast,
    WebsocketService,
    WebsocketRegisterType
  ) {
    /* jshint validthis:true */
    var vm = this;

    // current selected date
    vm.dt = null;

    // settings for ui element
    vm.options = {
      initDate: new Date(),
      showWeeks: false,
      startingDay: 1,
      yearRows: 4,
      yearColumns: 4,
      customClass: function (data) {
        return DateService.getDependingClass(data);
      },
    };

    // active datepicker
    activate();

    // when date changed
    vm.change = changeDate;
    // when mouse over
    vm.setToolTip = setToolTip;

    // function to set title
    function setToolTip(e) {
      var _propName = "date"; // date of calendarday

      // get date and set tooltip
      if (e.target.hasAttribute(_propName)) {
        var date = e.target.attributes[_propName].nodeValue;

        if (date !== "undefined" && date !== "") {
          var text = DateService.getDependingDateText(extractDateOnly(date));
          e.target.title = text !== "" ? text : "";
        }
      }
    }

    // function to change date
    function changeDate() {
      DateService.dateAndReload(vm.dt);
    }

    // extract date from datepicker date
    function extractDateOnly(date) {
      if (date.length > 11 && date.indexOf('"') !== -1) {
        var dateOnly = date.substring(0, 11);
        dateOnly = dateOnly.replace('"', "");

        return dateOnly;
      }
      return date;
    }

    function loadExtraDaysAndHolidays() {
      DateService.extraDaysAndHolidays().then(function () {        
        // set current date milliseconds (= model change -> datepicker refreshes)
        vm.dt = DateService.data.date.setMilliseconds(new Date().getMilliseconds());
      });
    }

    function activate() {
      //set current date -> raise refresh-event
      vm.dt = DateService.data.date;

      loadExtraDaysAndHolidays();
      listen();
    }
    function listen() {
      // listen on broadcast event when date has to be set
      var selectListener = $scope.$on(
        CalendarBroadcast.SelectDate,
        function (event, newDate) {
          if (vm.dt !== newDate) {
            // update date with selected date from outside
            vm.dt = newDate;
          }
        }
      );

      // listen for agenda changes
      var agendaChangedListener = $scope.$on(
        SharedAgendaBroadcast.AgendaChanged,
        loadExtraDaysAndHolidays
      );    

      // Listen to WS event "CalendarRefresh"
      var unregisterCalendarRefresh = WebsocketService.register(
                  WebsocketRegisterType.CalendarRefresh, 
                  function(response) {           
                    // check if the CalendarRefresh event is for the current displayed agenda => load holidays & refregh the calendar         
                    if (response.data.agendaId === SharedAgendaService.data.currentAgenda.id) {
                      loadExtraDaysAndHolidays();                      
                    }
                  }
                );     

      // on destroy
      $scope.$on("$destroy", function () {
        if (selectListener) {
          selectListener();
          selectListener = null;
        }

        if (agendaChangedListener) {
          agendaChangedListener();
          agendaChangedListener = null;
        }

        if (unregisterCalendarRefresh) {
           WebsocketService.unregister(unregisterCalendarRefresh.id); 
        }
      });
    }
  }
})();
